<template>
	<b-form-select
		v-model="salutation"
		:options="salutationOptions"
		@input="emitChangeEvent"
	/>
</template>

<script>
import {map} from "lodash";
import {SALUTATIONS} from "@/helper/form/Salutation";

export default {

	props: {
		value: {
			type: String,
			required: false,
		},
		placeholder: {
			type: String,
			required: false,
			default: '--- Anrede ---'
		}
	},

	data ()
	{
		return {
			salutation: this.value || null,
			salutationOptions: Object.freeze([
				{value: null, text: this.placeholder},
				...map(SALUTATIONS, (text, value) =>
				{
					return {value, text};
				})
			]),
		};
	},

	methods: {
		emitChangeEvent ()
		{
			this.$emit('input', this.salutation);
		},
	},

	watch: {
		value (v)
		{
			this.salutation = v;
		}
	}
}
</script>
